import React from 'react';
import {Modal} from "../../../../../components/modal/modal.jsx";
import Button from "../../../../../components/button/button.jsx";
import SelectComponent from "../../../../../components/select/select-component.jsx";
import {navigateHook} from "../../../../../hooks/use-navigate.js";

const ModalStorages = ({open, setOpen, storages, setStorageSelected, storageSelected}) => {
    const navigate = navigateHook();

    const goHome = () => {
        const urlDev = `/`;
        navigate(urlDev)
    }

    return (
        <Modal alignTop={true} open={open} setOpen={setOpen} overflow={true} showCloseButton={false} isCloseClick={false} centered size="md" backdrop="static" keyboard={false} title={"Selecione um depósito para continuar"} className={"w-4/12"}>
            <Modal.Body className="p-2">
                <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-12">
                        <SelectComponent
                            id="storage"
                            name="storage"
                            value={storageSelected}
                            options={storages || []}
                            label={"Depósito *"}
                            onChange={(selected) => {
                                setStorageSelected(selected)
                                setOpen(false)
                            }}
                        />
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer className={"p-1"}>
                <div className={"w-full flex justify-end gap-2"}>
                    <Button onClick={goHome}>
                        Voltar para home
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalStorages;